(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.product-description').forEach(function (block) {
    var content = block.querySelector('.product-description__content');
    var toggle = block.querySelector('.product-description__toggle');
    if (!content || !toggle) return;

    function updateToggleVisibility() {
      var isExpanded = content.classList.contains('is-expanded');
      if (isExpanded) return;
      toggle.hidden = content.scrollHeight <= content.clientHeight + 1;
    }

    toggle.addEventListener('click', function () {
      var expanded = content.classList.toggle('is-expanded');
      toggle.textContent = expanded ? 'Daha az göster' : 'Devamını gör';
    });

    updateToggleVisibility();
    window.addEventListener('resize', updateToggleVisibility);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-reviews-list"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var button = event.target.closest('.product-reviews-list__page-btn');
    if (!button) return;

    var pagination = button.closest('.product-reviews-list__pagination');
    var list = pagination && pagination.previousElementSibling;
    if (!list || !list.classList.contains('product-reviews-list')) return;

    var targetPage = button.dataset.page;

    list.querySelectorAll('.product-reviews-list__item').forEach(function (item) {
      item.hidden = item.dataset.page !== targetPage;
    });

    pagination.querySelectorAll('.product-reviews-list__page-btn').forEach(function (btn) {
      btn.classList.toggle('is-active', btn === button);
    });

    list.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["social-proof-notifications"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.pdp-notification').forEach(function (el) {
      var textEl = el.querySelector('[data-count]');
      var liveEl = el.querySelector('[data-live]');
      var icons = {
        purchase: el.querySelector('[data-icon="purchase"]'),
        viewing: el.querySelector('[data-icon="viewing"]'),
        cart: el.querySelector('[data-icon="cart"]')
      };

      var messages = [
        {
          icon: 'purchase',
          live: false,
          text: function () {
            var n = Math.floor(Math.random() * 45) + 15;
            return 'Son 24 saatte <strong>' + n + '</strong> kişi satın aldı';
          }
        },
        {
          icon: 'viewing',
          live: true,
          text: function () {
            var n = Math.floor(Math.random() * 35) + 8;
            return 'Şu an <strong>' + n + '</strong> kişi inceliyor';
          }
        },
        {
          icon: 'cart',
          live: false,
          text: function () {
            var n = Math.floor(Math.random() * 50) + 20;
            return 'Son 24 saatte <strong>' + n + '</strong> kişi sepete ekledi';
          }
        }
      ];

      var index = 0;

      function show() {
        var message = messages[index % messages.length];
        index++;

        Object.keys(icons).forEach(function (key) {
          icons[key].hidden = key !== message.icon;
        });
        textEl.innerHTML = message.text();
        liveEl.hidden = !message.live;

        el.classList.add('is-visible');
      }

      function cycle() {
        el.classList.remove('is-visible');
        window.setTimeout(show, 300);
      }

      show();
      window.setInterval(cycle, 4000);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
